import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function UserCheck({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>user-check</title>
      <defs>
        <path
          d="M12,12 C14.7614237,12 17,14.2385763 17,17 L17,19 C17,19.5522847 16.5522847,20 16,20 C15.4477153,20 15,19.5522847 15,19 L15,17 C15,15.3431458 13.6568542,14 12,14 L5,14 C3.34314575,14 2,15.3431458 2,17 L2,19 C2,19.5522847 1.55228475,20 1,20 C0.44771525,20 0,19.5522847 0,19 L0,17 C0,14.2385763 2.23857625,12 5,12 Z M22.2928932,6.29289322 C22.6834175,5.90236893 23.3165825,5.90236893 23.7071068,6.29289322 C24.0976311,6.68341751 24.0976311,7.31658249 23.7071068,7.70710678 L19.7071068,11.7071068 C19.3165825,12.0976311 18.6834175,12.0976311 18.2928932,11.7071068 L16.2928932,9.70710678 C15.9023689,9.31658249 15.9023689,8.68341751 16.2928932,8.29289322 C16.6834175,7.90236893 17.3165825,7.90236893 17.7071068,8.29289322 L19,9.58578644 Z M8.5,0 C11.2614237,0 13.5,2.23857625 13.5,5 C13.5,7.76142375 11.2614237,10 8.5,10 C5.73857625,10 3.5,7.76142375 3.5,5 C3.5,2.23857625 5.73857625,0 8.5,0 Z M8.5,2 C6.84314575,2 5.5,3.34314575 5.5,5 C5.5,6.65685425 6.84314575,8 8.5,8 C10.1568542,8 11.5,6.65685425 11.5,5 C11.5,3.34314575 10.1568542,2 8.5,2 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-1504, -253)">
          <g id="user-check" transform="translate(1504, 255)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(0, -2)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
